export const PASSWORD_FORMAT_REGEX = /^(?=.*[a-z])(?=.*[A-Z]).*$/
